import { homeCatalogSchema } from '@/features/veluvit/schemas/home.schema'

import type { HomeView } from '@/features/veluvit/schemas/home.schema'
import type { z } from 'zod'

export const HOME_CATALOG_PATH =
  '/bootstrap/?catalog=home&scope=home&initialize=false'

export function projectHome(
  catalog: z.infer<typeof homeCatalogSchema>
): HomeView {
  const { works, config } = catalog
  const known = new Set(works.map((work) => work.id))
  const home = config.home
  const sections = home?.sections ?? [
    { id: 'all', source: 'all' as const, workIds: home?.workIds ?? [] },
  ]
  return {
    banners: (home?.banners ?? []).filter((banner) => known.has(banner.workId)),
    sections: sections.map((section) => ({
      ...section,
      workIds: section.workIds.filter((workId) => known.has(workId)),
    })),
    works,
  }
}
